const initWindowConfig = () => {
  if (!window.fwplugins) {
    window.fwplugins = {
      listeners: {}, receivers: {}, configs: {}, callerParams: {},
    };
  }
};

/**
 * Funzione che ritorna il valore calledByParent salvato tra le variabili windows
 */
const getWindowCalledByParent = () => window.fwplugins && window.fwplugins.calledByParent;

/**
 * Funzione che scrive il valore calledByParent tra le variabili windows
 */
const setWindowCalledByParent = (calledByParent) => {
  initWindowConfig();
  window.fwplugins.calledByParent = calledByParent;
};

/**
 * Funzione che ritorna il valore dei parametri passati dal chiamante salvato tra le variabili windows
 */
const getWindowCallerParams = () => window.fwplugins && window.fwplugins.callerParams;

/**
  * Funzione che scrive il valore dei parametri passati dal chiamante tra le variabili windows
  */
const setWindowCallerParams = (callerParams) => {
  initWindowConfig();
  window.fwplugins.callerParams = callerParams;
};

/**
 * Funzione che ritorna il valore configs salvato tra le variabili windows
 * @param {*} name
 * @returns valore dello specifico config
 */
const getWindowConfig = (name) => window.fwplugins && window.fwplugins.configs && window.fwplugins.configs[name];

/**
  * Funzione che scrive il valore configs tra le variabili windows
  * @param {*} name
  * @param {*} value
  */
const setWindowConfig = (name, value) => {
  initWindowConfig();
  window.fwplugins.configs[name] = value;
};

/**
 * Metodo che consente la registrazione di un evento window solo se non è
 * già stato registrato per questo window
 * @param {*} type
 * @param {*} listener
 * @param {*} options
 * @param {string=} eventContext contesto di utilizzo dell'evento
 */
const addWindowEventListener = (type, listener, options, eventContext = '') => {
  initWindowConfig();
  if (!window.fwplugins.listeners[type + eventContext]) {
    window.addEventListener(type, listener, options);
    window.fwplugins.listeners[type + eventContext] = 1;
  } else {
    window.fwplugins.listeners[type + eventContext] += 1;
  }
};

/**
 * Metodo per gestire la rimozione dell'evento da window qual'ora sia
 * stato più volte registrato
 * @param {*} type
 * @param {*} listener
 * @param {*} options
 * @param {string=} eventContext contesto di utilizzo dell'evento
 */
const removeWindowEventListener = (type, listener, options, eventContext = '') => {
  initWindowConfig();
  if (window.fwplugins.listeners[type + eventContext] === undefined) {
    window.fwplugins.listeners[type + eventContext] = 0;
  } else if (window.fwplugins.listeners[type + eventContext] === 1) {
    window.removeEventListener(type, listener, options);
    window.fwplugins.listeners[type + eventContext] = 0;
  } else {
    window.fwplugins.listeners[type + eventContext] -= 1;
  }
};

const getWindowReceiverData = (idReceiver, dataName) => {
  initWindowConfig();
  if (!window.fwplugins.receivers[idReceiver]) {
    window.fwplugins.receivers[idReceiver] = { };
  }
  return window.fwplugins.receivers[idReceiver][dataName];
};

const setWindowReceiverData = (idReceiver, dataName, dataValue) => {
  initWindowConfig();
  if (!window.fwplugins.receivers[idReceiver]) {
    window.fwplugins.receivers[idReceiver] = { };
  }
  window.fwplugins.receivers[idReceiver][dataName] = dataValue;
};

export {
  getWindowCalledByParent,
  setWindowCalledByParent,
  addWindowEventListener,
  removeWindowEventListener,
  getWindowReceiverData,
  setWindowReceiverData,
  getWindowConfig,
  setWindowConfig,
  getWindowCallerParams,
  setWindowCallerParams,
};
